import React from 'react';
import TimeAgo from './time.js';
import Link, {skipToNative} from './link.js';
import Image from './image.js';
import {WrappingLoader} from './inline-loader.js';
import {reisy, use} from 'reisy';
import PropTypes from 'prop-types';
import Like from './like';
import Heading from './heading';
import TagList from './taglist.js';

const stylesheets = {
	normal: reisy`
	@namespace Article;

	ratio: 1;
	mobileRatio: 1;
	linkWrapArticle: false;

	CheckInViewport: false;
	CheckInViewportMargin: -100;

	showTags: false;

	inViewport {
		animation: $(Article.slideIn) .5s ease-out forwards;
	}
	instant {
		animation: none !important;
		opacity: 1 !important;
	}

	@keyframes slideIn {
		0% {
			transform: translateY(200px);
			opacity: 0;
		}
		100% {
			transform: translateY(0);
			opacity: 1;
		}
	}

	aCommon {
		a {
			text-decoration: none;
			color: inherit;
		}

		> a {
			flex: inherit;
			flex-direction: inherit;
			display: inherit;
			width: 100%;
		}
	}

	article {
		@extends Grid.item;
		@extends aCommon;
		a {
			/*display: block;
			position: relative;*/
		}
		$(Section.Container) & {
			$Media.medium {
				width: 25%;
			}
		}
	}

	link {
		@extends article;
	}

	img {
		
		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: auto;
		}
		& $(Image.backgroundImage) {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}
	}
	imgWrap {
		@extends Grid.itemImgWrap;
		flex-shrink: 0;
	}
	imgAspect {
		@extends Grid.itemImgAspect;
		height: auto;
		padding-top: 100%;
	}
	info {
		@extends Grid.itemInfo;
	}
	title {
		@extends Typography.ArticleTitle;
		margin: 0;

		$Section.hasBackground & {
			color: $Colors.TextLight;
		}
	}
	subtitle {
		@extends Typography.ArticleSubtitle;
		margin: .25em 0 0;

		$Section.hasBackground & {
			color: $Colors.TextLight;
		}
	}
	desc {
		@extends Typography.ArticleDesc;
		margin-top: .25em;
	}
	time {
		font-family: $Fonts.aside;
		font-size: 0.7em;
		color: $Colors.TextSubtle;
	}
	like {

	}
	Button { @extends Slide.Button; }
	aImg {
		@extends Helpers.AbsFull;
}`,
	tile: reisy`
	@namespace TileArticle;

	ratio: 1;
	mobileRatio: 1;
	linkWrapArticle: $Article.linkWrapArticle;

	showTags: $Article.showTags;

	inViewport { @extends Article.inViewport; }
	instant { @extends Article.instant; }
	aCommon { @extends Article.aCommon; }
	article { @extends Article.article; }
	link { @extends Article.link; }
	img { @extends Article.img; }
	imgWrap { @extends Article.imgWrap; }
	imgAspect { @extends Article.imgAspect; }
	info { @extends Article.info; }
	title { @extends Article.title; }
	subtitle { @extends Article.subtitle; }
	desc { @extends Article.desc; }
	time { @extends Article.time; }
	Button { @extends Article.Button; }
	aImg { @extends Article.aImg; }
`,
	tertiary: reisy`
	@namespace TertiaryArticle;

	ratio: 1;
	mobileRatio: 1;
	linkWrapArticle: $Article.linkWrapArticle;

	inViewport {
		@extends Article.inViewport;
	}	
	instant {
		@extends Article.instant;
	}

	aCommon { @extends Article.aCommon; }
	article {
		@extends Grid.itemTertiary;
		@extends Grid.item;
		@extends aCommon;
	}
	link {
		@extends article;
	}
	img {
		@extends Grid.itemTertiaryImgAspect;
		@extends Article.img;
	}
	imgWrap { @extends Article.imgWrap; }
	imgAspect { @extends Article.imgAspect; }
	info { @extends Article.info; }
	title { @extends Article.title; }
	subtitle { @extends Article.subtitle; }
	desc { @extends Article.desc; }
	time { @extends Article.time; }
	Button { @extends Article.Button; }
	aImg { @extends Article.aImg; }
`,
	loose: reisy`
	@namespace LooseArticle;

	ratio: 2;
	linkWrapArticle: $Article.linkWrapArticle;

	showTags: $Article.showTags;

	inViewport {
		@extends Article.inViewport;
	}
	instant {
		@extends Article.instant;
	}

	article {
		@extends Grid.itemPrimary;
		@extends Article.aCommon;
	}
	link {
		@extends article;
	}
	title { @extends PrimaryArticle.title; }
	subtitle { @extends PrimaryArticle.subtitle; }
	time { @extends PrimaryArticle.time; }
	ButtonWrap { }
	Button { @extends PrimaryArticle.Button; }
	desc { @extends Article.desc; }
	like { @extends Article.like; }
	imgWrap {
		@extends Grid.itemPrimaryImgWrap;
		$Media.small {
			width: $Grid.itemCol6;
		}
	}
	imgAspect {
		@extends Grid.itemPrimaryImgAspect;
	}
	aImg { @extends PrimaryArticle.aImg; }
	info {
		@extends Grid.itemPrimaryInfoWrap;
	}
`,
	primary: reisy`
	@namespace PrimaryArticle;

	ratio: 2;
	linkWrapArticle: $Article.linkWrapArticle;

	showTags: $Article.showTags;

	inViewport {
		@extends Article.inViewport;
	}
	instant {
		@extends Article.instant;
	}

	article {
		@extends Grid.itemPrimary;
		@extends Article.aCommon;
	}
	link {
		@extends article;
	}
	title {
		@extends Article.title;
		font-size: 1.85em;
		margin: 0;
	}
	subtitle {
		@extends Article.subtitle;
		font-size: 1.25em;
		margin: .25em 0 0;
	}
	time { @extends Article.time; }
	ButtonWrap { }
	Button { @extends Article.Button; }
	desc {
		@extends Article.desc;
		margin-top: .25em;
	}
	like { @extends Article.like; }
	imgWrap { @extends Grid.itemPrimaryImgWrap; }
	imgAspect { @extends Grid.itemPrimaryImgAspect; }
	aImg { @extends Helpers.AbsFull; }
	info {
		@extends Grid.itemInfo;
		@extends Grid.itemPrimaryInfoWrap;
	}
`,
	secondary: reisy`
	@namespace SecondaryArticle;

	ratio: 2;
	linkWrapArticle: $Article.linkWrapArticle;

	showTags: $Article.showTags;

	inViewport {
		@extends Article.inViewport;
	}
	instant {
		@extends Article.instant;
	}

	article {
		@extends Grid.itemSecondary;
		@extends Article.aCommon;
	}
	link {
		@extends article;
	}
	title { @extends Article.title; }
	subtitle { @extends Article.subtitle; }
	time { @extends Article.time; }
	ButtonWrap { }
	Button { @extends Article.Button; }
	desc { @extends Article.desc; }
	like { @extends Article.like; }
	imgWrap { @extends Grid.itemSecondaryImgWrap; }
	imgAspect { @extends Grid.itemSecondaryImgAspect; }
	aImg { @extends PrimaryArticle.aImg; }
	info {
		@extends Grid.itemInfo;
		@extends Grid.itemSecondaryInfoWrap;
	}
`};

const grid = reisy.namespace("Grid");
const settings = reisy.namespace("Settings");

function checkInViewport(elem) {
	if (!elem.offsetParent) { return false; }
	const MARGIN = stylesheets.normal.CheckInViewportMargin || 0;
	const viewport = {
		top: -MARGIN,
		right: window.innerWidth + MARGIN,
		bottom: window.innerHeight + MARGIN,
		left: -MARGIN,
	};
	const rect = elem.getBoundingClientRect();

	return rect.right >= viewport.left && rect.bottom >= viewport.top &&
		rect.left <= viewport.right && rect.top <= viewport.bottom;
}

// inline link wrapper that can be toggled on or off
// useful for switching between linking whole article
// or inline elements like image/title
const TogglableLink = ({renderLink, children, ...props}) => renderLink ? <Link {...props}>{children}</Link> : props.className ? <div {...use(props.className)}>{children}</div> : children;

class Article extends React.PureComponent {
	elem = React.createRef();
	
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			inViewport: false,
			instant: false,
		};

		let lastScroll = 0;
		let scrollCount = 0;
		this.listener = () => {
			if (this.state.inViewport && (scrollCount > 1 || !this.state.instant)) { return true; }
			const inViewport = checkInViewport(this.elem.current);
			const scroll = window.pageYOffset;
			if (scrollCount === 0) {
				lastScroll = scroll;
				scrollCount++;
				this.setState({
					inViewport: true,
					instant: !inViewport,
				});
				return false;
			} else if (scrollCount === 1 && lastScroll !== scroll) {
				scrollCount++;
				this.setState({
					inViewport,
					instant: false,
				});
				return inViewport;
			}
			if (!inViewport) { return false; }
			this.setState({
				inViewport: true,
				instant: false,
			});
			return true;
		};
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick(ev) {
		if (skipToNative(ev) || this.props.article.type === 'link') { return; }
		this.setState({loading: true});
	}
	componentWillReceiveProps(props) {
		if (props.article !== this.props.article) {
			this.setState({loading: false});
		}
	}
	componentDidMount() {
		if (!IS_BROWSER) { return; }
		this.componentDidUpdate();
	}
	componentWillUnmount() {
		if(stylesheets.normal.CheckInViewport) window.removeEventListener('scroll', this.listener, true);
	}
	componentDidUpdate() {
		this.componentWillUnmount();
		if (stylesheets.normal.CheckInViewport) {
			if (!this.listener()) {
				window.addEventListener('scroll', this.listener, true);
			}
		}
	}
	render() {
		let {article, collection, button, style, hierarchy = null, index} = this.props;
		const {loading, inViewport, instant} = this.state;
		const to = article.options && article.options.href || article.href || {append: hierarchy && hierarchy.concat([article]) || [collection, article]};
		const styling = this.props.styling || 'normal';
		const styles = stylesheets[styling];

		let wideMobileRatio;
		switch (grid.mobileLayout) {
		case 'auto':
			wideMobileRatio = index === 0 ? 2 : 1;
			break;
		case 'tile':
			wideMobileRatio = 1;
			break;
		default:
			wideMobileRatio = 2;
		}

		const target = article.type === 'link' ? (article.options && article.options.target || '_blank') : null;

		const tags = article.tags.length > 0 && article.tags.map(tag => `Tag-${tag.name.split(' ').join('-')}`);
		const taglist = styles.showTags && article.tags ? 
			<TagList publishable={article} filter={styles.showTags.startsWith && styles.showTags.startsWith('/') ? i => i.name.match(new RegExp(styles.showTags.slice(1,-1))) : undefined} /> 
			: null;

		let articleEl;

		switch (styling) {
			case 'loose':
			case 'primary':
			case 'secondary':
				articleEl = (
					<article
						{...use(article.type === 'link' ? styles.link : styles.article,
						inViewport && styles.inViewport,
						instant && styles.instant,
						article.options && article.options.className,
						article.backgroundColor && {background: `#${article.backgroundColor}`},
						tags && tags)} ref={this.elem} lang={article.locale}>

						<TogglableLink renderLink={styles.linkWrapArticle} onClick={this.handleClick} to={to} target={target}>
							{article.image
								? <div {...use(styles.imgWrap)}>
									<div {...use(styles.imgAspect)}>
										<TogglableLink renderLink={!styles.linkWrapArticle} onClick={this.handleClick} to={to} target={target} {...use(styles.aImg)}>
											<WrappingLoader loading={loading}>
												<Image
													style={styles.img}
													image={article.image}
													imageOptions={article.imageOptions}
													ratio={(
														// normal ratio for first articles
														(IS_BROWSER && window.innerWidth < 900)
															? styles.mobileRatio || wideMobileRatio
															: styles.ratio) || 2}
													sizes={styles.imageSizes || "32em"}
													availWidth={740}
													alt={article.title}
													cover lazy placeholder />
											</WrappingLoader>
										</TogglableLink>
									</div>
								</div>
								: null}
							<div {...use(styles.info)}>
								<TogglableLink renderLink={!styles.linkWrapArticle} onClick={this.handleClick} to={to} target={target}>
									<Heading lvl={3} {...use(styles.title)}>{article.title}</Heading>
								</TogglableLink>
								{article.subTitle ? <p {...use(styles.subtitle)}>{article.subTitle}</p> : null}
								{article.description ? <div {...use(styles.desc)}>{article.description}</div> : null}
								{taglist}
								{settings.ShowTime && <TimeAgo {...use(styles.time)} time={article.publishDate} />}
								{settings.showLike && <Like {...use(styles.like)} publishable={article} />}
							</div>
							{button && <TogglableLink renderLink={!styles.linkWrapArticle} onClick={this.handleClick} to={to}><div {...use(styles.Button)} target={target}>{button}</div></TogglableLink>}
						</TogglableLink>
					</article>
				); break;

			default:
				articleEl = (
					<article {...use(article.type === 'link' ? styles.link : styles.article, inViewport && styles.inViewport, instant && styles.instant, article.options && article.options.className,
						article.backgroundColor && {background: `#${article.backgroundColor}`},
						tags && tags)} ref={this.elem} lang={article.locale}>
						<TogglableLink renderLink={styles.linkWrapArticle} onClick={this.handleClick} to={to} target={target}>
							{article.image
								? <div {...use(styles.imgWrap)}>
									<div {...use(styles.imgAspect)}>
										<TogglableLink renderLink={!styles.linkWrapArticle} {...use(styles.aImg)} onClick={this.handleClick} to={to} target={target}>
											<WrappingLoader loading={loading}>
												<Image
													style={styles.img}
													image={article.image}
													imageOptions={article.imageOptions}
													ratio={((IS_BROWSER && window.innerWidth < 900) ? styles.mobileRatio : styles.ratio) || 1}
													sizes={styles.imageSizes || "32em"}
													availWidth={300}
													alt={article.title}
													cover lazy placeholder />
											</WrappingLoader>
										</TogglableLink>
									</div>
								</div>
								: null}
							<div {...use(styles.info)}>
								<Heading lvl={3} {...use(styles.title)}>
									<TogglableLink renderLink={!styles.linkWrapArticle} {...use(styles.ButtonWrap)} onClick={this.handleClick} to={to} target={target}>{article.title}</TogglableLink>
								</Heading>
								{article.subTitle ? <p {...use(styles.subtitle)}>{article.subTitle}</p> : null}
								{article.description ? <div {...use(styles.desc)}>{article.description}</div> : null}
								{taglist}
								{settings.ShowTime && <TimeAgo {...use(styles.time)} time={article.publishDate} />}
								{settings.showLike && <Like {...use(styles.like)} publishable={article} />}
							</div>
							{button && <Link {...use(styles.ButtonWrap)} onClick={this.handleClick} to={to} target={target}><div {...use(styles.Button)}>{button}</div></Link>}
						</TogglableLink>
					</article>
				); break;
		}

		return (
			articleEl
		);
	}
}

Article.propTypes = {
	button: PropTypes.string,
	article: PropTypes.object.isRequired,
	collection: PropTypes.object,
	styling: PropTypes.oneOf(['normal', 'tile', 'loose', 'primary', 'secondary', 'tertiary']),
};

Article.contextTypes = {
  player: PropTypes.object
};

export default Article;



// WEBPACK FOOTER //
// ./lib/components/article.js